import { List } from "components/List/List";
import { useBreak } from "hooks/useBreak";
import { Scrollbar } from "react-scrollbars-custom";
import { useAtom } from "jotai";
import { useEffect, useRef } from "react";
import { active_unit, fullViewMode } from "state/store.global";
import { Box } from "@mui/material";

/* -------------------------------------------------------
   Helper: check visibility inside container
------------------------------------------------------- */
const isElementInContainerView = (el, container, offset = 0) => {
  if (!el || !container) return false;

  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return (
    elRect.top >= containerRect.top - offset &&
    elRect.bottom <= containerRect.bottom + offset
  );
};

export const ViewList = ({ clr }) => {
  const isDesktop = useBreak("md_up");
  const isMobile = useBreak("md_dn");

  const [active] = useAtom(active_unit);
  const [viewMode] = useAtom(fullViewMode);

  const lastScrolledUnit = useRef(null);
  const scrollContainerRef = useRef(null);

  /* -------------------------------------------------------
     Scroll ONLY if selected unit is outside view
  ------------------------------------------------------- */
  useEffect(() => {
    if (!active?.UnitID) return;

    if (lastScrolledUnit.current === active.UnitID) return;

    const el = document.getElementById(`unitid_${active.UnitID}`);
    const container = scrollContainerRef.current;

    if (!el || !container) return;

    const isVisible = isElementInContainerView(el, container, 16);

    if (!isVisible) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    lastScrolledUnit.current = active.UnitID;
  }, [active?.UnitID]);

  /* -------------------------------------------------------
     Wrapper
  ------------------------------------------------------- */
  const Wrapper = ({ children }) => {
    if (viewMode === "split") {
      return (
        <Box
          ref={scrollContainerRef}
          sx={{
            width: "100%",
            height: isMobile
              ? "calc(100% - 73px)"
              : "calc(100% - 165.4px)",
            backgroundColor: "#ffffff",
            overflowY: "auto",
            scrollbarWidth: "none",
            paddingRight: "8px",
            borderRight: "1px solid #2B3C4926",
          }}
        >
          {children}
        </Box>
      );
    }

    return <>{children}</>;
  };

  return (
    <Wrapper>
      {isDesktop ? (
        <Scrollbar
          scrollerProps={{ ref: scrollContainerRef }}
          trackYProps={{
            renderer: ({ elementRef, ...rest }) => (
              <span
                {...rest}
                ref={elementRef}
                className="trackY"
                style={rest.style}
              />
            ),
          }}
        >
          <RenderComponent />
        </Scrollbar>
      ) : (
        <RenderComponent />
      )}
    </Wrapper>
  );
};

const RenderComponent = () => <List />;
